function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import React, { Component } from 'react';
import { arrayOfObjectsToObject } from '@finect/front-utils/arrayOfObjectsToObject';
import { FIELDS_TYPES } from '../data';
import { getViewType, getEmptyInitialValue, isUnlock } from '../FieldForm/utils';
import { getStepRelatives, getInitialStep, getAppFields } from '../utils/steps';
import { updateSession } from './actions';
var getInitialStateFromProps = function getInitialStateFromProps(props) {
  var _props$initialFields = props.initialFields,
    initialFields = _props$initialFields === void 0 ? {} : _props$initialFields;
  var fields = getAppFields(props.app);
  var firstStep = getInitialStep(props.app, initialFields);
  return {
    fetching: false,
    currentFlow: 'steps',
    session: props.session || null,
    currentStepName: firstStep.field,
    fields: fields.map(function (item) {
      var emptyInitial = getEmptyInitialValue(item);
      var initialValue = initialFields.hasOwnProperty(item.field) ? initialFields[item.field] : emptyInitial;
      return {
        field: item.field,
        lastValue: item.lastValue,
        value: initialValue,
        unlocked: isUnlock(item, initialValue),
        emptyInitial: initialValue
      };
    })
  };
};
export function withPill(WrappedComponent) {
  var withAppComponent = function (_Component) {
    _inherits(withAppComponent, _Component);
    var _super = _createSuper(withAppComponent);
    function withAppComponent() {
      var _this;
      _classCallCheck(this, withAppComponent);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _defineProperty(_assertThisInitialized(_this), "state", getInitialStateFromProps(_this.props));
      _defineProperty(_assertThisInitialized(_this), "getRelatives", function () {
        var stepValues = arrayOfObjectsToObject(_this.state.fields.map(function (_ref) {
          var field = _ref.field,
            value = _ref.value;
          return {
            field: field,
            value: value
          };
        }), 'field', 'value');
        var currentField = _this.state.fields.find(function (item) {
          return item.field === _this.state.currentStepName;
        });
        return getStepRelatives(_this.state.currentStepName, _this.props.app.steps, currentField.value, stepValues);
      });
      _defineProperty(_assertThisInitialized(_this), "handlePrevStep", function () {
        var currentIndex = _this.props.app.steps.findIndex(function (item) {
          return item.field === _this.state.currentStepName;
        });
        _this.setState({
          currentStepName: _this.props.app.steps[currentIndex - 1].field
        });
      });
      _defineProperty(_assertThisInitialized(_this), "handleNextStep", function () {
        var _ref2 = _this.props.auth || {},
          token = _ref2.token;
        _this.setState({
          fetching: true
        }, function () {
          var _ref3 = _this.state.session || {},
            _ref3$id = _ref3.id,
            id = _ref3$id === void 0 ? null : _ref3$id;
          var fields = _this.state.fields.filter(function (item) {
            return item.unlocked;
          }).map(function (_ref4) {
            var field = _ref4.field,
              value = _ref4.value;
            return {
              field: field,
              value: value
            };
          });
          var currentIndex = _this.props.app.steps.findIndex(function (item) {
            return item.field === _this.state.currentStepName;
          });
          var isLast = !(currentIndex < _this.props.app.steps.length - 1);
          var response = updateSession(_this.props.app.id, id, fields, isLast ? 'completed' : 'uncompleted', {
            token: token
          });
          response.then(function (session) {
            var _this$getRelatives = _this.getRelatives(),
              nextStep = _this$getRelatives.nextStep;
            if (isLast) {
              _this.setState({
                currentFlow: 'result',
                session: session
              });
            } else {
              _this.setState({
                fetching: false,
                session: session,
                currentStepName: _this.props.app.steps[nextStep.order - 1].field
              });
            }
          }).catch(function () {
            _this.setState({
              fetching: false
            });
          });
        });
      });
      _defineProperty(_assertThisInitialized(_this), "handleFieldChange", function (field, value) {
        var fieldDefinition = _this.props.app.fields.find(function (item) {
          return item.field === field;
        });
        var viewType = getViewType(fieldDefinition);
        var validator = FIELDS_TYPES[viewType].validator;
        var newFields = _this.state.fields.map(function (item) {
          if (item.field === field) {
            return _objectSpread(_objectSpread({}, item), {
              value: value,
              unlocked: validator(fieldDefinition, value)
            });
          }
          return item;
        });
        _this.setState(function (state) {
          return _objectSpread(_objectSpread({}, state), {
            fields: newFields
          });
        });
      });
      _defineProperty(_assertThisInitialized(_this), "handleResultsAction", function () {
        var onResultsAction = _this.props.onResultsAction;
        if (onResultsAction) {
          onResultsAction({
            app: _this.props.app,
            session: _this.state.session
          });
        }
      });
      return _this;
    }
    _createClass(withAppComponent, [{
      key: "render",
      value: function render() {
        var _this2 = this;
        var currentIndex = this.props.app.steps.findIndex(function (item) {
          return item.field === _this2.state.currentStepName;
        });
        var currentField = this.state.fields.find(function (_ref5) {
          var fieldName = _ref5.field;
          return fieldName === _this2.state.currentStepName;
        });
        var stepValues = arrayOfObjectsToObject(this.state.fields.map(function (_ref6) {
          var field = _ref6.field,
            value = _ref6.value;
          return {
            field: field,
            value: value
          };
        }), 'field', 'value');
        var relatives = getStepRelatives(this.state.currentStepName, this.props.app.steps, currentField.value, stepValues);
        var pillProps = {
          actions: {
            onPrevStep: this.handlePrevStep,
            onNextStep: this.handleNextStep,
            onChange: this.handleFieldChange,
            onResultsAction: this.handleResultsAction
          },
          pillState: _objectSpread(_objectSpread({}, this.state), {
            isLoading: this.state.fetching,
            currentIndex: currentIndex,
            currentField: this.state.fields.find(function (item) {
              return item.field === _this2.state.currentStepName;
            }),
            hasPrevStep: currentIndex > 0,
            hasNextStep: currentIndex < this.props.app.steps.length - 1,
            nextStep: relatives.nextStep
          })
        };
        return React.createElement(WrappedComponent, _extends({
          pillProps: pillProps
        }, this.props));
      }
    }]);
    return withAppComponent;
  }(Component);
  return withAppComponent;
}